@if (isEmpty()) {
  <div class="empty-cell">Empty</div>
}

@if (!isEmpty()) {
  <div>
    @switch (field) {
      @default {
        <div class="default-value">{{ getDefaultValue() }}</div>
      }
      @case ('activities') {
        <div>
          <gymfinder-changelog-options [options]="value" [fieldType]="'activities'" />
        </div>
      }
      @case ('services') {
        <div>
          <gymfinder-changelog-options [options]="value" [fieldType]="'services'" />
        </div>
      }
      @case ('gymEquipments') {
        <div>
          <gymfinder-changelog-options-strings
            [options]="value"
            [fieldType]="'gymEquipments'" />
        </div>
      }
      @case ('equipmentsToBring') {
        <div>
          <gymfinder-changelog-options-strings
            [options]="value"
            [fieldType]="'equipmentsToBring'" />
        </div>
      }
      @case ('gymInfos') {
        <div>
          <gymfinder-changelog-options-strings
            [options]="value"
            [fieldType]="'gymInfos'" />
        </div>
      }
      @case ('gymTypes') {
        <div>
          <gymfinder-changelog-options-strings
            [options]="value"
            [fieldType]="'gymTypes'" />
        </div>
      }
      @case ('openingHoursV2') {
        <div>
          <gymfinder-changelog-opening-hours [openingHoursV2]="value" />
        </div>
      }
      @case ('externalBookingInfo') {
        <div>
          <gymfinder-changelog-external-booking-info [externalBookingInfo]="value" />
        </div>
      }
      @case ('gymImages') {
        <div>
          <gymfinder-changelog-images [gymImages]="value" />
        </div>
      }
      @case ('studioType') {
        <div>
          <gymfinder-changelog-studio-type [studioType]="value" />
        </div>
      }
      @case ('geniusFeatures') {
        <div>
          <gymfinder-changelog-options-strings
            [options]="value"
            [fieldType]="'geniusFeatures'" />
        </div>
      }
    }
  </div>
}
